import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";


const EmailsHistoryLogList = Loadable(
  lazy(() =>
    import("./EmailsHistoryLogList").then(({ EmailsHistoryLogList }) => ({
      default: EmailsHistoryLogList,
    }))
  )
);

export const EmailsRoutes = [
  {
    path: `/emails-history-log`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <EmailsHistoryLogList />
      </AuthorizedRoute>
    ),
  },
]